import React, { useEffect, useState } from 'react';
import GlobalPaymentsController from '../../../../API/GlobalPaymentsAPIs/GlobalPaymentsController';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import STC from '../../../../STCLibrary/STCFactory/STCFactory';
import './PaymentComplete.css'
import ColouredLoadingSymbol from '../../../../STCLibrary/LoadingAnimation/ColouredLoadingSymbol/ColouredLoadingSymbol';

export default function PaymentComplete(){

    const routeParams = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true)
    const [linkInfo, setLinkInfo] = useState();
    const [errorMsg, setErrorMsg] = useState('');

    const [searchParams, setSearchParams] = useSearchParams();
    const linkID = searchParams.get('link_id');

    const getPaymentInfo = () => {
        GlobalPaymentsController.GetLinkInfo(linkID)
        .then((response) => {
            if(response.status === 200){
                setLinkInfo(response.data);
                const postJSON = {
                    amount: parseFloat(response.data.transactions.amount / 100).toFixed(2),
                    payerId: routeParams.userID,
                    bookingId: response.data.name,
                    portalPassengerId: routeParams.passengerID,
                    createdDate: response.data.transactions.transaction_list[0].time_created
                }
                GlobalPaymentsController.SaveSuccessfulPayment(postJSON)
                .then((response) => {
                    if(response.status === 200){
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setErrorMsg("Error saving payment details.")
                })
                
            }
            
        })
        .catch((err) => {
            console.log(err);
            setErrorMsg('Error loading payment details.')
        })
    }

    useEffect(() => {
        getPaymentInfo();
    }, []);

    if(loading){
        return(
            <div >
                <ColouredLoadingSymbol/>
            </div>
        )
    }
    else{
        return(
            <div className="payment-complete-container h-100">
                <div>
                    <STC.Logo.Bordered/>
                </div>
                <h1>Payment Complete</h1>
                <div className="result-box">{linkInfo.description}</div>
                <div className="result-box">Amount Paid: {linkInfo.transactions.currency} {(linkInfo.transactions.amount / 100).toFixed(2)}</div>
                <div className="ref-box">Reference: {linkInfo.reference}</div>
              
                <div className="button-container">
                    <STC.Button onClick={() => navigate('/' + routeParams.userID + '/payment-history')}>Go to Payments</STC.Button>
                </div>
            </div>
        )
    }
}
